export default "__VITE_ASSET__i6W5qh33__"